"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryCity = void 0;
var _DaoServiceClientES6Adapter = _interopRequireWildcard(require("@/utils/daoService/DaoServiceClientES6Adapter"));
var _request = _interopRequireDefault(require("@/utils/request"));
var countryCity = exports.countryCity = _DaoServiceClientES6Adapter.default.QCdmCountry.using(_DaoServiceClientES6Adapter.dsc);

/* 根据id删除 */
countryCity.deleteTypeById = function (id) {
  return countryCity.deleteById(id);
};
// 联想控件查询
countryCity.queryAsCountry = function (query) {
  if (query.countryCode !== undefined) {
    query.countryCode = query.countryCode || null;
  }
  if (query.countryNameCn !== undefined) {
    query.countryNameCn = query.countryNameCn || null;
  }
  if (query.countryNameEn !== undefined) {
    query.countryNameEn = query.countryNameEn || null;
  }
  return (0, _request.default)({
    url: '/ebusiness/autocomplete/queryListCountry',
    method: 'get',
    params: query
  });
};
countryCity.exportCountry = function (query) {
  return _DaoServiceClientES6Adapter.dsc.withModel(countryCity).forExport(countryCity.id, countryCity.countryCode, countryCity.countryNameCn, countryCity.countryNameEn, countryCity.activeFlag).where(countryCity.countryCode.like(_DaoServiceClientES6Adapter.___).and(countryCity.id.eq(_DaoServiceClientES6Adapter.___)).and(countryCity.countryNameEn.like(_DaoServiceClientES6Adapter.___)).and(countryCity.countryNameCn.like(_DaoServiceClientES6Adapter.___)).and(countryCity.activeFlag.like(_DaoServiceClientES6Adapter.___))).tag('Test_Country_Export_List_Xlsx').execute(query);
};
/* 根据Code获取 */
countryCity.getByCode = function (query) {
  return countryCity.select(countryCity.fieldContainer()).where(countryCity.countryCode.eq(_DaoServiceClientES6Adapter.___).and(countryCity.deletedFlag.eq(_DaoServiceClientES6Adapter.___))).execute(query);
};